import script from "./LogoEdit.vue?vue&type=script&setup=true&lang=js"
export * from "./LogoEdit.vue?vue&type=script&setup=true&lang=js"

import "./LogoEdit.vue?vue&type=style&index=0&id=0db170d6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0db170d6"]])

export default __exports__